module.exports = __webpack_public_path__ + "static/media/organisms2.7a15c30f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/design-specifications/assets/organisms2.png
// module id = 75
// module chunks = 0